import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class ButtonComponent {

  @Input() type: string;
  @Input() cssClass: string;
  @Input() backButton = false;
  @Input() buttonText: string;
  @Input() disabled = false;
  @Input() showSpinner = false;
}
